import { createContext, useCallback, useEffect, useState } from "react";
import { confirm } from "react-confirm-box";
import { useDispatch } from "react-redux";
import CommonModal from "../common/modal/CommonModal";
import CommonPasswordModal from "../common/modal/PasswordModal";
// import { PRODUCT_STOCK_REPORT, USERS_TAB } from "./tab/tabUtilsConstants";
import { displayToast } from "./toast/toastUtils";
import { canAccessScreen } from "../utils/accessUtils";
const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);
  // const [enableGlobalNavigation, setEnableGlobalNavigation] = useState(true);
  const [currentComponent, setCurrentComponent] = useState("");
  const [goToTab, setGoToTab] = useState(null);
  const [goToNextTab, setGoToNextTab] = useState(false);
  const [goToPrevTab, setGoToPrevTab] = useState(false);
  const [closeCurrentTab, setCloseCurrentTab] = useState(false);
  const [addNewTab, setAddNewTabState] = useState(null);
  const setAddNewTab = useCallback((tab) => {
    if (tab?.component && !canAccessScreen(tab.component)) {
      displayToast({
        type: "error",
        title: "You do not have access to this screen.",
      });
      return;
    }
    setAddNewTabState(tab);
  }, []);
  const [focusLastRow, setFocusLastRow] = useState(true);
  const [terminal, setTerminal] = useState("gNofy");
  const [user, setUser] = useState("admin");
  const [showGlobalShortcuts, setShowGlobalShortcuts] = useState(false);
  const [showAddProductAutocomplete, setShowAddProductAutocomplete] =
    useState(false);
  const [showSpotlight, setShowSpotlight] = useState(false);
  const [barcode, setBarcode] = useState("");
  const [componentBeforeScan, setComponentBeforeScan] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [tallyExportInProgress, setTallyExportInProgress] = useState(false);
  const [loadingTimeout, setLoadingTimeout] = useState(null);

  const dispatch = useDispatch();
  const focusElement = useCallback((id) => {
    document.getElementById(id)?.focus({ preventScroll: true });
  }, []);
  const globalKeydownListener = useCallback((e) => {
    const key = e.key?.toLowerCase();
    const altKey = e.altKey;
    const ctrlKey = e.ctrlKey;
    const shiftKey = e.shiftKey;
    if (altKey) e.preventDefault();
    if (key === "tab") e.preventDefault();
    if (key === "arrowdown") e.preventDefault();
    if (key === "arrowup") e.preventDefault();
    if (key === "delete") e.preventDefault();
    if (key === "f1") e.preventDefault();
    if (key === "f2") e.preventDefault();
    if (key === "f3") e.preventDefault();
    if (key === "f4") e.preventDefault();
    if (key === "f5") e.preventDefault();
    if (key === "f6") e.preventDefault();
    if (key === "f7") e.preventDefault();
    if (key === "f8") e.preventDefault();
    if (key === "f9") e.preventDefault();
    if (key === "f10") e.preventDefault();
    if (
      ctrlKey &&
      ([1, 2, 3, 4, 5, 6, 7, 8, 9].includes(+key) ||
        key === "d" ||
        key === "f" ||
        key === "g" ||
        key === "j" ||
        key === "l" ||
        key === "o" ||
        key === "p" ||
        key === "s" ||
        key === "w" ||
        key === "u" ||
        key === "h" ||
        key === "e" ||
        key === "n" ||
        key === "tab" ||
        key === "t" ||
        (!shiftKey && key === "r") ||
        (shiftKey && key === "tab"))
    ) {
      e.preventDefault();
    }
  }, []);
  const globalKeyupListener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const shiftKey = e.shiftKey;
      const altKey = e.altKey;
      const ctrlKey = e.ctrlKey;
      if (ctrlKey) {
        // if (!shiftKey && key === "tab") {
        if (key === "arrowright") {
          setGoToNextTab(true);
          return;
        }
        // if (shiftKey && key === "tab") {
        if (key === "arrowleft") {
          setGoToPrevTab(true);
          return;
        }
        if ([1, 2, 3, 4, 5, 6, 7, 8, 9].includes(+key)) {
          setGoToTab(+key - 1);
          return;
        }
        if (key === "w") {
          setCloseCurrentTab(true);
          return;
        }
        if (autocompleteOpen) return;
        // if (key === "l") {
        //   setShowGlobalShortcuts(true);
        //   return;
        // }
        // if (key === "m") {
        //   setShowAddProductAutocomplete(true);
        //   return;
        // }
        if (key === " ") {
          setShowSpotlight(true);
          return;
        }
      }
      //load modules

      //3 short-cut keys

      //2 short-cut keys

      //1 short-cut key

      if (showSpotlight) {
        if (key === "escape") {
          setShowSpotlight(false);
          return;
        }
      }

      if (
        currentComponent?.startsWith("grid") ||
        currentComponent?.startsWith("list_nav") ||
        currentComponent === "login_signin_button" ||
        currentComponent === "prescriptions-autocomplete" ||
        currentComponent === "view-prescriptions" ||
        currentComponent === "gstr_reports" ||
        (document.getElementsByClassName("MuiAutocomplete-listbox").length >
          0 &&
          key !== "tab") ||
        document.getElementsByClassName("grid-popper").length > 0
      ) {
        console.info("skipping marker");
        return;
      }
      const el = document.activeElement;
      const markers = el.getAttribute("data-markers")
        ? JSON.parse(el.getAttribute("data-markers"))
        : null;
      if (
        currentComponent === "common-modal" ||
        currentComponent === "password-modal"
      ) {
        if (key === "arrowleft") {
          if (markers?.left) focusElement(markers.left);
          return;
        }
        if (key === "arrowright") {
          if (markers?.right) focusElement(markers.right);
          return;
        }
        if (key === "enter") {
          document.activeElement.click();
          return;
        }
      }
      if (key === "tab" || key === "enter") {
        document.activeElement.blur();
        if (!markers) {
          setCurrentComponent("default_focus");
          return;
        }
        if (shiftKey) {
          if (markers.left) focusElement(markers.left);
          return;
        }
        if (markers.right) {
          focusElement(markers.right);
          return;
        }
      }
      if (key === "arrowdown") {
        document.activeElement.blur();
        if (!markers) {
          setCurrentComponent("default_focus");
          return;
        }
        if (altKey) {
          if (markers.altDown) focusElement(markers.altDown);
          return;
        }
        if (markers.down) focusElement(markers.down);
        return;
      }
      if (key === "arrowup") {
        document.activeElement.blur();
        if (!markers) {
          setCurrentComponent("default_focus");
          return;
        }
        if (altKey) {
          if (markers.altUp && markers.altUp.startsWith("grid")) {
            setFocusLastRow(false);
            setCurrentComponent(markers.altUp);
            return;
          }
          if (markers.altUp) focusElement(markers.altUp);
          return;
        }
        if (markers.up && markers.up.startsWith("grid"))
          return setCurrentComponent(markers.up);
        if (markers.up) focusElement(markers.up);
        return;
      }
    },
    [autocompleteOpen, currentComponent, focusElement, showSpotlight]
  );
  const focusField = useCallback(
    (id, preserveFocus = true, rowIndex = null, column = null) => {
      if (!id) return;
      setCurrentComponent(id);
      if (preserveFocus) {
        dispatch({
          type: "update_current_focus",
          payload: { id, rowIndex, column },
        });
      }
    },
    [dispatch]
  );
  const displayModal = async (props) => {
    setCurrentComponent("common-modal");
    let result = await confirm("", {
      render: (title, onOk, onCancel) => (
        <CommonModal
          onOk={() => {
            setTimeout(() => {
              setCurrentComponent(null);
            }, 100);
            onOk();
          }}
          onEscape={() => {
            setTimeout(() => {
              setCurrentComponent(null);
            }, 100);
            onCancel();
          }}
          onClose={() => {
            setTimeout(() => {
              setCurrentComponent(null);
            }, 100);
            onCancel();
          }}
          onCancel={() => {
            setTimeout(() => {
              setCurrentComponent(null);
            }, 100);
            onCancel();
          }}
          {...props}
        />
      ),
    });
    return !!result;
    // if (result) return true;
    // return false;
  };
  const displayPasswordModal = async () => {
    setCurrentComponent("password-modal");
    let result = await confirm("", {
      render: (title, onOk, onCancel) => (
        <CommonPasswordModal
          onError={(message) => {
            displayToast({ type: "error", title: message });
          }}
          onOk={() => {
            setCurrentComponent(null);
            onOk();
          }}
          onCancel={() => {
            setCurrentComponent(null);
            onCancel();
          }}
          onEscape={() => {
            setCurrentComponent(null);
            onCancel();
          }}
        />
      ),
    });
    return !!result;
    // if (result) return true;
    // return false;
  };

  const findCategory = useCallback((categories, categoryId) => {
    for (const category of categories) {
      if (category.categoryId === categoryId) {
        return category;
      }
      if (category.childs && category.childs.length > 0) {
        const result = findCategory(category.childs, categoryId);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }, []);

  useEffect(() => {
    if (!loadingTimeout && showLoading) {
      setLoadingTimeout(
        setTimeout(() => {
          displayToast({
            type: "error",
            title: "It's taking too long. Please contact support.",
          });
          setShowLoading(false);
        }, 20000)
      );
    } else if (!showLoading) {
      if (loadingTimeout) {
        clearTimeout(loadingTimeout);
      }
      setLoadingTimeout(null);
    }
  }, [loadingTimeout, showLoading]);
  useEffect(() => {
    if (!showSpotlight) {
      document.addEventListener("keydown", globalKeydownListener, false);
    }
    return () => {
      document.removeEventListener("keydown", globalKeydownListener, false);
    };
  }, [globalKeydownListener, showSpotlight]);
  useEffect(() => {
    if (!showSpotlight) {
      document.addEventListener("keyup", globalKeyupListener, false);
    }
    return () => {
      document.removeEventListener("keyup", globalKeyupListener, false);
    };
  }, [globalKeyupListener, showSpotlight]);
  useEffect(() => {
    console.log("GC", currentComponent);
  }, [currentComponent]);
  return (
    <GlobalContext.Provider
      value={{
        autocompleteOpen,
        setAutocompleteOpen,
        // enableGlobalNavigation,
        // setEnableGlobalNavigation,
        currentComponent,
        setCurrentComponent,
        goToNextTab,
        setGoToNextTab,
        goToPrevTab,
        setGoToPrevTab,
        addNewTab,
        setAddNewTab,
        goToTab,
        setGoToTab,
        closeCurrentTab,
        setCloseCurrentTab,
        terminal,
        setTerminal,
        user,
        setUser,
        showGlobalShortcuts,
        setShowGlobalShortcuts,
        showAddProductAutocomplete,
        setShowAddProductAutocomplete,
        showSpotlight,
        setShowSpotlight,
        focusLastRow,
        setFocusLastRow,
        barcode,
        setBarcode,
        componentBeforeScan,
        setComponentBeforeScan,
        showLoading,
        setShowLoading,
        focusField,
        displayModal,
        displayPasswordModal,
        tallyExportInProgress,
        setTallyExportInProgress,
        findCategory,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
export default GlobalContext;
